import React from 'react'
import { Link as ReactLink } from 'react-router-dom'

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string
  children: React.ReactNode
}

const isInternal = (to: string) => {
  if (to.indexOf('://') === -1) return true
  const parser = document.createElement('a')
  parser.href = to
  return window.location.hostname === parser.hostname
}

const Link: React.FC<LinkProps> = ({ to, children, ...rest }) => {
  if (isInternal(to)) {
    return (
      <ReactLink to={to} {...rest}>
        {children}
      </ReactLink>
    )
  } else {
    return (
      <a href={to} {...rest}>
        {children}
      </a>
    )
  }
}

export default Link
